let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lWfUq")).then(() => parcelRequire('iXVts'));